import React from 'react';

import { type MarketBoxes } from '@/common/types/shop/marketBoxes';
import { useAppSelector } from '@/redux/store';

import BoxCard from './BoxCard/BoxCard';

const BoxMarket: React.FC = () => {
  const boxList = useAppSelector((state) => state.shop.shopPacks);
  const smallCards: MarketBoxes[] = ['free', 'ads', 'starter'] as const;
  const mediumCards: MarketBoxes[] = ['pro', 'gold'] as const;
  const bigCards: MarketBoxes[] = ['elit'] as const;

  const smallBoxes =
    boxList?.filter((box) => smallCards.includes(box.name)) || [];
  const mediumBoxes =
    boxList?.filter((box) => mediumCards.includes(box.name)) || [];
  const bigBoxes = boxList?.filter((box) => bigCards.includes(box.name)) || [];

  const mainBoxes = bigBoxes.length ? bigBoxes : mediumBoxes;

  return (
    <div className="flex flex-col gap-[16px] mt-[16px]">
      <div key="small" className="flex gap-[6px]">
        {smallBoxes.map((box) => (
          <BoxCard key={box.name} {...box} cardType="small" />
        ))}
      </div>
      {!!bigBoxes.length && (
        <div key="medium" className="flex gap-[10px]">
          {mediumBoxes.map((box) => (
            <BoxCard key={box.name} {...box} cardType="medium" />
          ))}
        </div>
      )}
      <div key="big" className="flex">
        {mainBoxes.map((box) => (
          <BoxCard key={box.name} {...box} cardType="big" />
        ))}
      </div>
    </div>
  );
};

export default BoxMarket;
